module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view spec"
  }, [(_vm.spec) ? _c('specsheet', {
    attrs: {
      "localspec": _vm.spec
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.deleteSpec()
      }
    }
  }, [_vm._v("Slet")]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Projekt"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spec.project_key),
      expression: "spec.project_key"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.spec, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('project_key', $event)
      }]
    }
  }, _vm._l((_vm.all_projects), function(project, key, i) {
    return _c('option', {
      domProps: {
        "value": project.key
      }
    }, [_vm._v(_vm._s(project.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), (false) ? _c('btn', {
    attrs: {
      "full": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01426c8d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Spec.vue
// module id = 576
// module chunks = 1